import { Tooltip, Typography } from 'antd'
import { CSSProperties } from 'react'
const { Text } = Typography

export type Props = {
  units: string
} & Pick<CSSProperties, 'width' | 'maxWidth' | 'fontSize'>

const MAX_UNIT_LABEL_LENGTH = 10;

const Units = ({ fontSize = 'inherit', maxWidth, units, width }: Props) => {
  const excessiveUnitLabelLength = units.length > MAX_UNIT_LABEL_LENGTH
  return <Text style={{ fontSize, maxWidth, width, color: 'currentcolor' }}>
  { excessiveUnitLabelLength ?
    <Tooltip title={units} >
      {units.substring(0,MAX_UNIT_LABEL_LENGTH-3) + "…"}
    </Tooltip>
    :
    units 
  }
  </Text>
}
export default Units
